import { render, staticRenderFns } from "./CustomerResources.vue?vue&type=template&id=1a52cd82&"
import script from "./CustomerResources.vue?vue&type=script&lang=js&"
export * from "./CustomerResources.vue?vue&type=script&lang=js&"
import style0 from "./CustomerResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports